
function toCurrencyFormat(snumber) {
    return parseFloat(snumber).toLocaleString("en-US", {style:"currency", currency:"USD", minimumFractionDigits:2, maximumFractionDigits: 2});
}

function toNumberFormat(snumber) {
    return parseFloat(snumber).toLocaleString("en-US", {style:"decimal", minimumFractionDigits:2, maximumFractionDigits: 2});
}

function resetbackgroundColorSelected(){
  document.getElementById('select-size').getElementsByClassName('select-size-1')[0].style.backgroundColor = "transparent";  
  document.getElementById('select-size').getElementsByClassName('select-size-1')[1].style.backgroundColor = "transparent"; 
  document.getElementById('select-size').getElementsByClassName('select-size-1')[2].style.backgroundColor = "transparent"; 
  document.getElementById('select-size').getElementsByClassName('select-size-1')[3].style.backgroundColor = "transparent"; 
  document.getElementById('select-size').getElementsByClassName('select-size-1')[4].style.backgroundColor = "transparent"; 
  document.getElementById('select-size').getElementsByClassName('select-size-1')[5].style.backgroundColor = "transparent"; 
  document.getElementById('select-size').getElementsByClassName('select-size-1')[6].style.backgroundColor = "transparent"; 
  document.getElementById('select-size').getElementsByClassName('select-size-1')[7].style.backgroundColor = "transparent";
  document.getElementById('select-size').getElementsByClassName('select-size-1')[8].style.backgroundColor = "transparent"; 
  document.getElementById('select-size').getElementsByClassName('select-size-1')[9].style.backgroundColor = "transparent"; 
  
}

function allImage(){   
   console.log('allImage');  

    fetch("https://my-solitaire.myshopify.com/assets", {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},            
    }).then(response => {
          console.log('response',response);  
        })
        .catch(error => console.error('Error:', error)); 

    
}

// Calculate Greatest Common Divisor
function gcd(a, b) {
    if (b === 0) {
      return a;
    }
    return gcd(b, a % b);
  }
  
  // Convert a decimal number to a simplified fraction
  function decimalToFraction(decimal) {
    const integerPart = Math.floor(decimal);
    let fractionPart = decimal - integerPart;
  
    // Define the precision for converting the fraction part
    const precision = 1000000;
    
    let numerator = Math.round(fractionPart * precision);
    let denominator = precision;
  
    // Simplify the fraction
    const commonDivisor = gcd(numerator, denominator);
    numerator /= commonDivisor;
    denominator /= commonDivisor;
  
    // Construct the output string
    let output = '';
    if (integerPart !== 0) {
      output += integerPart;
    }
  
    if (numerator !== 0) {
      if (integerPart !== 0) {
        output += ' ';
      }
      output += `${numerator}/${denominator}`;
    }
  
    if (integerPart === 0 && numerator === 0) {
      output = '0';
    }
  
    return output;
  }

function loaddata(productId,variantSku,shape,settingMetal,settingCarat){

    fetch('https://1yi00t63hl.execute-api.us-east-1.amazonaws.com/v1/' + productId)
        .then(response => response.json())
        .then(data => {
            data = data;
            /**
             * Look for the images in the data array named 'dyor_setting_' + sku + '_' + shape + '_' + carat + '_' + metal_position; 
             * 
             */
            console.log("data",data);
            console.log("VariantSku",variantSku);
            /* let's convert the settingCarat to a fraction */
            console.log("Setting Carat",settingCarat);
            settingCaratFraction = decimalToFraction(parseFloat(settingCarat)).replace("/","-");


            let shapesMetalAndSkuImages = data.filter(function(image){

                return image.includes(variantSku) && image.includes(shape.toLowerCase()+"_"+settingCaratFraction) && image.includes('dyor') && image.includes(settingMetal.toLowerCase());
            });

            console.log("Found Images",shapesMetalAndSkuImages);

            for (let index = 0; index < shapesMetalAndSkuImages.length; index++) {
                let img = document.getElementById("diamond-img"+(index+1));
                //img.classList.add('img-diamond-picture');
                img.getElementsByTagName('img')[0].src=shapesMetalAndSkuImages[index];
            }

            
        
        
        });
    /*jQuery.getJSON(window.Shopify.routes.root + `products/${productHandle}.js`, function(product) {
        
        if(product && product.images){
            //Search for images with the same variant sku
            let images = product.images.filter(function(image){
                return image.includes(variantSku) && image.includes(shape) && image.includes('dyor');
            });
            if(images.length === 0){
             
                 images = [
                    'https://dummyimage.com/420x420/c9c9c9/000000?text=dyor_'+variantSku+'_'+shape+'_1',
                    'https://dummyimage.com/420x420/c9c9c9/000000?text=dyor_'+variantSku+'_'+shape+'_2',
                    'https://dummyimage.com/420x420/c9c9c9/000000?text=dyor_'+variantSku+'_'+shape+'_3',
                    'https://dummyimage.com/420x420/c9c9c9/000000?text=dyor_'+variantSku+'_'+shape+'_4',
                    'https://dummyimage.com/420x420/c9c9c9/000000?text=dyor_'+variantSku+'_'+shape+'_5'
                ];
            }
           
            
        }
      });*/
}

function ResetImgs (){   
    let  imgNum = 1;  
    let img;
    for (let index = 0; index < 10; index++) {
        img=document.getElementById("diamond-img"+imgNum); 
        img.classList.remove('img-diamond-picture');  
        img.getElementsByTagName('img')[0].src="";   
        imgNum=imgNum+1; 
    }
}

function loadUrlImages(){
    let imgs = [
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_5.png?v=1665590060",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_6_-_copia_2.png?v=1665590060",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_3_-_copia_2.png?v=1665590060",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_2.png?v=1665590060",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_2_-_copia_2.png?v=1665590060",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_3.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_2_-_copia_1.png?v=1665590060",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_2_-_copia_3.png?v=1665590060",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4_-_copia_-_copia.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_3_-_copia.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_5_-_copia.png?v=1665590060",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_1.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_6_-_copia.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
    ];  

    return imgs;

}

async function createProductObject(diamond_id){    
    let url = window.API_URL +`diamonds/new/dyor/settings/${diamond_id}`;   
    let producto;
    var product = await fetch(url, {
        method: 'POST',
        headers: {'Content-Type': 'application/json','X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM'},            
    }).then(res => res.json())
     .then(async product => {    
     producto = product;
   }).catch(error => console.error('Error:', error));   

   return producto;
}

async function existProduct(diamond_id){ 
  let url = window.API_URL +`diamonds/new/dyor/settings/${diamond_id}`; 
  let diamond;
  var result = await fetch(url, {
        method: 'GET',
        headers: {'Content-Type': 'application/json','X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM'},            
    }).then(res => res.json())
     .then(async result => {          
       diamond = result;
       console.log(diamond);
   }).catch(error => console.error('Error:', error));    
    return diamond;

}

async function createProductFinish(){
  let infoRing = JSON.parse(localStorage.getItem('wizardInfo_dyoe'));   
  console.log('infoRing', infoRing);
  let diamondProduct= await existProduct(infoRing.stone_id);
  console.log('diamondProduct', diamondProduct);

  if (diamondProduct.shopify_product_id == null) {
     let newProduct = await createProductObject(infoRing.stone_id);  // creo un producto     
     console.log('newProduct', newProduct);
  }

  let url = window.API_URL +`diamonds/new/dyor/settings/create/ring`;  
  let finishProduct;
  console.log('infoRing.stone_id PRE', infoRing.stone_id);   
  
  settingVariantId = infoRing.setting_variant_id?infoRing.setting_variant_id:41138478645384;
  console.log('URL', url);
  console.log('infoRing.stone_id', infoRing.stone_id);    
  console.log('infoRing.setting_variant_id', infoRing.setting_variant_id);
  
  let editMode = localStorage.getItem('editMode');
  // if(editMode !== null){
  //   let removalUrl = window.localStorage.getItem('urlToRemove');
  //   fetch(removalUrl, {
  //       method: 'POST',
  //       headers: {'Content-Type': 'application/json'},
  //       body: JSON.stringify({quantity: 0})
  //   }).then(response => {
  //       window.localStorage.removeItem('editMode');
  //       window.localStorage.removeItem('urlToRemove');
  //       window.localStorage.removeItem('wizardStart');
  //       window.localStorage.removeItem('latestSearch');
  //       fetch(url, {
  //           method: 'POST',
  //           body: JSON.stringify({
  //             "diamond_id":infoRing.stone_id,
  //             "variant_id":infoRing.setting_variant_id
  //           }),
  //           headers: { 'Content-type': 'application/json'}
  //       }).then(res => res.json())
  //           .then(product => {    
  //               console.log('product', product);    
  //             addCart(product);
  //           })
  //           .catch(error => console.error('Error:', error));
  //           }
  //       )
  // }
 // else {
   var settingImage=infoRing.setting_image_url;
 if(infoRing.setting_image_url == undefined || infoRing.setting_image_url == null){
    settingImage='';
  }
  var wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_dyoe'));
var stone_carat = parseFloat(wizardInfo.stone_carat);
var greater_no  = 0;
var frection_no =0;
var obj = JSON.parse($('.dyor_obj').attr('data-obj'));

for(i=0;i<obj.sizes.values.length;i++){
    
    var carat_val = parseFloat(obj.sizes.values[i].value);
    if(stone_carat <= carat_val){
        greater_no = carat_val
        frection_no = obj.sizes.values[i].key
         break;
    }
   
   
}

  
  if($('.accent_stone_val[data-carat="'+frection_no+'"][data-shape="'+wizardInfo.stone_shape+'"]').length > 0){
  accent_stone_val = $('.accent_stone_val[data-carat="'+frection_no+'"][data-shape="'+wizardInfo.stone_shape+'"]').html();
  }else{
    accent_stone_val = $('.accent_stone_val[data-carat="1"][data-shape="'+wizardInfo.stone_shape+'"]').html();
  }
  
  fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          "diamond_id":infoRing.stone_id,
          "diamond_id1":infoRing.stone_id1,
          "variant_id":infoRing.setting_variant_id,
          "product_image":settingImage
          
        }),
        headers: { 'Content-type': 'application/json','X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM'}
    }).then(res => res.json())
        .then(product => {    
            console.log('product', product);    
          addCart(product);
        })
        .catch(error => console.error('Error:', error));

//}
}

function addCart(product){    
  console.log('product',product);
   let infoRing = JSON.parse(localStorage.getItem('wizardInfo_dyoe'));
  let currentCurrency = Shopify.currency.active;
  let currentCurrencySymbol = $('body').attr('data-currency');
  let currentRate = window.Shopify.currency.rate;  
  let id = parseInt(product.variants[0].id);
  let pid = infoRing.setting_variant_id;
  let selectImage = infoRing.setting_image_url;
  let selectProductname = infoRing.setting_product_name;
  let selectVariantPrice= infoRing.setting_variant_price;
  let stoneCarat = infoRing.stone_carat;
  let stoneClarity = infoRing.stone_clarity;
  let stoneColor = infoRing.stone_color;
  let stoneCut = infoRing.stone_cut;
  let deliver_date = $('#deliverydate').text().replace(",", ".");
  let stoneDelivery = $('#deliverydate').text().replace(",", ".");
  let stoneImage = infoRing.stone_image_url;
  let stonePrice = infoRing.stone_price;
  let stoneShape = infoRing.stone_shape;
  let certificate_number = infoRing.stone_certificate_no;
  let certificate_type = infoRing.stone_certificate_type;
  let vendor_name = infoRing.stone_vendor_name;
  let earring_product = true;
  let items = [];
  let stoneCarat1 = infoRing.stone_carat1;
  let stoneClarity1 = infoRing.stone_clarity1;
  let stoneColor1 = infoRing.stone_color1;
  let stoneCut1 = infoRing.stone_cut1;
  let stoneImage1 = infoRing.stone_image_url1;
  let stonePrice1 = infoRing.stone_price1;
  let stoneShape1 = infoRing.stone_shape1;
  let certificate_number1 = infoRing.stone_certificate_no1;
  let certificate_type1 = infoRing.stone_certificate_type1;
  let vendor_name1 = infoRing.stone_vendor_name1;

  
  infoRing.final_deliver = $('#deliverydate').text().replace(",", ".");
  localStorage.setItem('wizardInfo_dyoe',JSON.stringify(infoRing));
  let wizardInfo = JSON.stringify(localStorage.getItem('wizardInfo_dyoe'));
  
  let wizardStart = localStorage.getItem('wizardStart');
    items.push({'id': id ,'quantity': 1,properties: {'_earring_product':earring_product, '_wizardInfo': wizardInfo, '_wizardStart': wizardStart, '_pid': pid, '_selectVariantPrice':selectVariantPrice, '_image': selectImage, '_pname': selectProductname, '_stoneClarity': stoneClarity, '_stoneColor': stoneColor, '_stoneCut':stoneCut, '_stoneCarat': stoneCarat, '_stoneDelivery': stoneDelivery,'_deliver_date': deliver_date, '_stoneImage':stoneImage,'_stonePrice':stonePrice, '_stoneShape':stoneShape,'_vendor_name':vendor_name,'_certificate_type':certificate_type,'_certificate_number':certificate_number, '_stoneClarity1': stoneClarity1, '_stoneColor1': stoneColor1, '_stoneCut1':stoneCut1, '_stoneCarat1': stoneCarat1, '_stoneImage1':stoneImage1,'_stonePrice1':stonePrice1, '_stoneShape1':stoneShape1,'_vendor_name1':vendor_name1,'_certificate_type1':certificate_type1,'_certificate_number1':certificate_number1  }});
        let body = {
        "items": items
        }
  fetch((window.Shopify.routes.root +"cart/add.js"), {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(body)       
    }).then(response => {
          console.log('response',response);      
          console.log('ADDED'); 
          let url = window.Shopify.routes.root+"cart";
         var nacklace_container_step = localStorage.getItem("nacklace_container_step");
        var diamond_step = localStorage.getItem("diamond_page_step");
        if(nacklace_container_step != null){
          window.localStorage.removeItem('nacklace_container_step');
        }
        if(diamond_step != null){
          window.localStorage.removeItem('diamond_page_step');
        }
          localStorage.setItem('Product_Added',true);
          window.location.href = url;  
        })
        .catch(error => console.error('Error:', error)); 

  
}

function bindEventsAddCart(){
  let btnText = null;
   document.getElementById('diamond-with-setting').addEventListener('click', event => {
     
  
    // Change the innerHTML property with a list of sentences
    let messages = ['Please wait...','Crafting your diamond....','Crafting your setting...','Almost there...'];
    let spinner = ` <svg class="tw-w-10 tw-h-10" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
    <g fill="none" fill-rule="evenodd">
        <g transform="translate(1 1)" stroke-width="2">
            <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
            <path d="M36 18c0-9.94-8.06-18-18-18">
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 18 18"
                    to="360 18 18"
                    dur="1s"
                    repeatCount="indefinite"/>
            </path>
        </g>
    </g>
</svg>`;
    btnText = event.target.innerHTML;
    let sInt = setInterval(function(){
        let random = Math.floor(Math.random() * messages.length);
        event.target.innerHTML = spinner + " "+ messages[random];
    }, 2000);

     let infoRing = JSON.parse(localStorage.getItem('wizardInfo_dyoe'));
     let url = window.API_URL +`diamonds/new/dyor/settings/${infoRing.stone_id}`;      
     fetch(url, {
        method: 'GET',        
        headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
     }).then(res => res.json())
      .then(async diamond => {
        if(diamond && diamond.Diamond_ID2) {
          createProductFinish();
        } else {
          clearInterval(sInt);
          event.target.innerHTML = btnText;
          $('body').append("<div id='stock-modal'><div onclick='$(this).parent().remove();' class='stock-modal-close'>X</div>We're so sorry the diamond you selected is no longer available, please choose another before placing your order.</div>");
        }
          
      })
      .catch(error => console.error('Error:', error));
  
    });
}

function bindEventsSelectSize(sizeDefault){
    let button = document.getElementById('button-select'); 
    document.querySelectorAll('#select-size > .select-size-1').forEach((opciones)=>{
        opciones.addEventListener('click',(e)=>{
           
            let valor =e.currentTarget.getElementsByTagName('h2')[0].innerHTML; 
            let imgs = loadUrlImages();            
            let img;
            let imgsFilter=[];
            let imgNum = 1;
           


        });
   });  
}

function bindEvents() {   
  var wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_dyoe'));  
if(wizardInfo != null){
var url = `https://api.yotpo.com/products/hy0FXvQK9F7NqR9gOcdBwKagN70j3HK132bcQuQQ/${wizardInfo.setting_product_id}/bottomline`
fetch(url)
        .then(response => response.json())
        .then(data => {
            console.log(data);
          
          if(data.response.bottomline.total_reviews > 0){
            if(data.response.bottomline.average_score > 0 && data.response.bottomline.average_score <1){
             $('a.ir218-stars.ir218-stars-small').css('background-position','left -12px');
            }else if(data.response.bottomline.average_score == 1){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -26px');
            }
            else if(data.response.bottomline.average_score > 1 && data.response.bottomline.average_score <2){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -39px');
            }
            else if(data.response.bottomline.average_score  == 2 ){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -52px');
            }
            else if(data.response.bottomline.average_score > 2 && data.response.bottomline.average_score < 3){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -66px');
            }
            else if(data.response.bottomline.average_score = 3){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -78px');
            }
            else if(data.response.bottomline.average_score > 3 && data.response.bottomline.average_score < 4){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -91px');
            }
            else if(data.response.bottomline.average_score = 4){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -103px');
            }
            else if(data.response.bottomline.average_score > 4 && data.response.bottomline.average_score < 5){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -117px');
            }
            else if(data.response.bottomline.average_score = 5){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -129px');
            }
         $('.reviews-badgets .ir218-write-read a').html(`(${data.response.bottomline.total_reviews})`)
          }else{
            $('.reviews-badgets').hide();
          }
        })
}
    //bindEventsSelectSize();
    bindEventsAddCart();
}
var wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_dyoe'));


if(wizardInfo != null){
   var diamond_id = wizardInfo.stone_id;
   var handle = wizardInfo.setting_product_handle;
   var purpose ='get_carat_val'
   getProductImage(handle,purpose);
  

  
   var img_url =wizardInfo.setting_image_url;
   var pd_sku =wizardInfo.setting_variant_sku.toLocaleLowerCase();
   var p_id =wizardInfo.setting_product_id;
   var ston_shap =wizardInfo.setting_selected_shape.toLocaleLowerCase();
   var carat_val_deci = 0;
   var carat_val_2 =1/2;
   var carat_val_3 = '1/2';
   var carat_val_4;
   var carat_val ;
   var setting_selected_metal=wizardInfo.setting_selected_metal.toLowerCase().replace(/[^a-z0-9]+/g, '').replace(/-$/, '').replace(/^-/, '');
   var carat_size =wizardInfo.stone_carat;
    var flag =0;
    var flag1 = 0;
    var product_carat_value1 =localStorage.getItem('product_carat_dyoe');
    if(product_carat_value1 != null){
    var carart_val = product_carat_value1;
    var carat_val1 = carart_val.split(",");
    $(carat_val1).each(function(index,e){
    carat_val_2=e.split("|")[1];
    carat_val_2= _.replace(carat_val_2, "/","-");
          var carat_val_deci=parseFloat(this.split("|")[0]);
          if(carat_val_deci != ''){
          if(carat_val_deci == carat_size){
             change_url = 'false';
          }
            if(carat_val_deci <= carat_size && flag1 == 0){
              carat_val_3 = carat_val_2;
              flag =1;
            }else if(carat_val_deci >= carat_size && flag == 0){
              flag1 = 1
              carat_val_3 = carat_val_2;
            }
          }
          });
        
          var sku = `dyoe_setting_${pd_sku }`
          if(carat_val_3.indexOf('-') > -1){
             
          if(carat_val_3.length >= 3){
            var position = 1
            carat_val_4 = [carat_val_3.slice(0, position), carat_val_3.slice(position)].join(' ');
            }
            carat_val=carat_val_4.replace('-','/');
           }else{
            carat_val = carat_val_3;
         }


          var aws_img =false;
          var new_url = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${sku}_${carat_val_3}_${setting_selected_metal}`
         if(p_id == 7485213048968 || p_id == 7431068811400){
           var new_url_check = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${sku}_${carat_val_3}_${setting_selected_metal}_1.jpg`
         }else{
           var new_url_check = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${sku}_${carat_val_3}_${setting_selected_metal}-1.jpg`
         }

         
         checkImageExists(new_url_check, function(exists) {
           var count = 0;
            if (exists) {  
              wizardInfo.setting_image_url = new_url_check
              localStorage.setItem('wizardInfo_dyoe',JSON.stringify(wizardInfo));
              //$(`#grid-img-diamond #diamond-img6,div#carouselExampleIndicators .carousel-inner #diamond-img6`).html(`<video playsinline="playsinline" controls="controls" autoplay="autoplay" loop="loop" preload="none" muted="muted" aria-label='' poster='' src=${main_url}><source src=${main_url} type="video/mp4"></video><div class="Fraction_number">Shown with ${carat_val} Carat ${ston_shap} Diamond</div>`)
             checkImageExists(`${new_url}-1.jpg`, function(exists) {
                 if (exists) { 
                   
                    count = count+1;
              $(`#grid-img-diamond #diamond-img1 ,div#carouselExampleIndicators .carousel-inner #diamond-img1`).html(`<img src='${new_url}-${1}.jpg'alt=""> <div class="Fraction_number">Shown with ${carat_val} Carat ${ston_shap} Diamond</div>`);
                 }else{
                   $(`#grid-img-diamond #diamond-img1`).remove()
                 }
                })
              checkImageExists(`${new_url}-2.jpg`, function(exists) {
                 if (exists) { 
                    count = count+1;
              $(`#grid-img-diamond #diamond-img4 ,div#carouselExampleIndicators .carousel-inner #diamond-img4`).html(`<img src='${new_url}-${2}.jpg'alt=""> <div class="Fraction_number">Shown with ${carat_val} Carat ${ston_shap} Diamond</div>`);
                 }else{
                   $(`#grid-img-diamond #diamond-img4`).remove()
                 }
                })
               checkImageExists(`${new_url}-3.jpg`, function(exists) {
                 if (exists) { 
                    count = count+1;
              $(`#grid-img-diamond #diamond-img5 ,div#carouselExampleIndicators .carousel-inner #diamond-img5`).html(`<img src='${new_url}-${3}.jpg'alt=""> <div class="Fraction_number">Shown with ${carat_val} Carat ${ston_shap} Diamond</div>`);
                 }else{
                   $(`#grid-img-diamond #diamond-img5`).remove()
                 }
                })
               $(`#grid-img-diamond #diamond-img6 ,div#carouselExampleIndicators .carousel-inner #diamond-img6`).html(`<video playsinline="playsinline" controls="controls" autoplay="autoplay" loop="loop" preload="none" muted="muted" aria-label='' poster='' src='${new_url}-4.mp4'><source src='${new_url}-4.mp4' type="video/mp4"></video><div class="Fraction_number">Shown with ${carat_val} Carat ${ston_shap} Diamond</div>`);
                checkImageExists(`${new_url}-5.jpg`, function(exists) {
                 if (exists) { 
              $(`#grid-img-diamond #diamond-img7 ,div#carouselExampleIndicators .carousel-inner #diamond-img7`).html(`<img src='${new_url}-${5}.jpg'alt=""> <div class="Fraction_number">Shown with ${carat_val} Carat ${ston_shap} Diamond</div>`);
                 }else{
                   $(`#grid-img-diamond #diamond-img7`).remove()
                 }
                })
               checkImageExists(`${new_url}-6.jpg`, function(exists) {
                 if (exists) { 
                    count = count+1;
              $(`#grid-img-diamond #diamond-img8 ,div#carouselExampleIndicators .carousel-inner #diamond-img8`).html(`<img src='${new_url}-${6}.jpg'alt=""> <div class="Fraction_number">Shown with ${carat_val} Carat ${ston_shap} Diamond</div>`);
                 }else{
                   $(`#grid-img-diamond #diamond-img8`).remove()
                 }
                })
               checkImageExists(`${new_url}-7.jpg`, function(exists) {
                 if (exists) { 
                    count = count+1;
              $(`#grid-img-diamond #diamond-img9 ,div#carouselExampleIndicators .carousel-inner #diamond-img9`).html(`<img src='${new_url}-${7}.jpg'alt=""> <div class="Fraction_number">Shown with ${carat_val} Carat ${ston_shap} Diamond</div>`);
                 }else{
                   $(`#grid-img-diamond #diamond-img9`).remove()
                 }
                })
               //$(`#grid-img-diamond #diamond-img${i+2} ,div#carouselExampleIndicators .carousel-inner #diamond-img${i+2}`).html(`<img src=${main_url} alt=""><div class="Fraction_number">Shown with ${carat_val} Carat ${ston_shap} Diamond</div>`);
               myVar = setInterval( informUser, 100);
              function informUser(){
                 var empty_len = parseInt($('.carousel-inner .product-diamond-images:empty').length);
                 var container =  parseInt($('.carousel-inner .product-diamond-images').length);
                 var total_ava = parseInt(container-empty_len-3);
                 console.log("<<<<<<<Vtytotal available"+total_ava);
                if(count >= total_ava ){ //changescompleteearringslider
                  $('.carousel-inner .product-diamond-images:not(#diamond-img3,#diamond-img2)').each(function(){
                  if ($(this).is(':empty')) {
                     $(this).remove(); 
                  }
                  })
 
                
                  $('.carousel .carousel-inner').slick({dots:true,arrows:true})
                  clearInterval(myVar);
                }
              }
         }else{
           if(wizardInfo != null || wizardInfo != undefined){
            var handle = wizardInfo.setting_product_handle;
            var purpose= 'get_img'
            getProductImage(handle,purpose)
            }
            }
           })
    }else{
     var wizardInfo = JSON.parse(localStorage.getItem("wizardInfo_dyoe"));
     if(wizardInfo != null || wizardInfo != undefined){
     var handle = wizardInfo.setting_product_handle;
     var purpose= 'get_img'
     getProductImage(handle,purpose)
    }
    }
  }else{
    localStorage.removeItem("wizardStart")
    window.location.href=window.location.origin;
  }


function getProductImage(handle,purpose) {

  
  var purpose = purpose;
  $.ajax({
    url: `/products/${handle}?view=dyoe-setting`,
    type: 'GET',
    success: function(res) {
      let qntymore = $(res).find('.get_attr_main').attr('data-quantity_more');
      let qntyless = $(res).find('.get_attr_main').attr('data-quantity_less');
      let inventory_qty = $(res).find('.get_attr_main').attr('data-inventory_qty');
      let vprice = $(res).find('.get_attr_main').attr('data-vprice');

      console.log(purpose);
      if(purpose == 'get_carat_val'){
        calcDeliveryDate(inventory_qty,qntymore,qntyless,vprice);
      var product_carat =  parseFloat($(res).find('.product.product--stacked').attr('data-carat-size'));
      var stone_carat =   parseFloat(wizardInfo.stone_carat);
      var total_carat_size = product_carat+stone_carat;
      
       total_carat_size = total_carat_size.toFixed(2)
        if(!isNaN(total_carat_size)){
        $('#ring-short-detail').html(`Your total diamond weight is ${total_carat_size} carats of diamonds`);
        }
      }
        //console.log($(res).find('.product__media-list').html());
       if(purpose == 'get_img'){
       var count =0;
        $(res).find('.product__media-list li').each(function(index,ele){
            if($(this).find('deferred-media').length >0){
               var aria_label =$(this).find('deferred-media video').attr('aria-label');
              var video_src =  $(this).find('deferred-media video source').attr('src');
                var poster_img = $(this).find('deferred-media video img').attr('src');
             $(`#grid-img-diamond #diamond-img6,div#carouselExampleIndicators .carousel-inner .diamond-img5`).html(`<video playsinline="playsinline" controls="controls" autoplay="autoplay" loop="loop" preload="none" muted="muted" aria-label='' poster='' src=${video_src}><source src=${video_src} type="video/mp4"><img src='${poster_img}'></video>`)
             }else{
            var Img_src = $(this).find('modal-opener .product__media img').attr('src');
               if(index == 0){
                 count= count+1;
          $(`#grid-img-diamond #diamond-img1 ,div#carouselExampleIndicators .carousel-inner .diamond-img1`).html(`<img src=${Img_src} alt="">`);
              }else if(index == 1){
                 count= count+1;
                 $(`#grid-img-diamond #diamond-img4 ,div#carouselExampleIndicators .carousel-inner .diamond-img4`).html(`<img src=${Img_src} alt="">`);
              }else if(index == 2){
                 count= count+1;
                 $(`#grid-img-diamond #diamond-img5 ,div#carouselExampleIndicators .carousel-inner .diamond-img5`).html(`<img src=${Img_src} alt="">`);
              }else if(index == 3){
                 count= count+1;
                 $(`#grid-img-diamond #diamond-img6 ,div#carouselExampleIndicators .carousel-inner .diamond-img6`).html(`<img src=${Img_src} alt="">`);
              }else if(index == 4){
                 count= count+1;
                 $(`#grid-img-diamond #diamond-img7 ,div#carouselExampleIndicators .carousel-inner .diamond-img7`).html(`<img src=${Img_src} alt="">`);
              }else if(index == 5){
                 count= count+1;
                 $(`#grid-img-diamond #diamond-img8 ,div#carouselExampleIndicators .carousel-inner .diamond-img8`).html(`<img src=${Img_src} alt="">`);
              }
              
            }
        });
          myVar = setInterval( informUser, 100);
              function informUser(){
                 var empty_len = parseInt($('.carousel-inner .product-diamond-images:empty').length);
                 var container =  parseInt($('.carousel-inner .product-diamond-images').length);
                 var total_ava = parseInt(container-empty_len-2);
              
                if(count >= 3){
                if(count == total_ava ){
                  $('.carousel-inner .product-diamond-images:not(#diamond-img3,#diamond-img2)').each(function(){
                  if ($(this).is(':empty')) {
                     $(this).remove(); 
                  }
                  })
                  $('.carousel .carousel-inner').slick({dots:true,arrows:true})
                  clearInterval(myVar);
                }
                }
              }
       }
    }
});
}
getdiamond_img(diamond_id)

function loadInfoRing(){
    //allImage(); 

    let infoRing = JSON.parse(localStorage.getItem('wizardInfo_dyoe'));    

    if (infoRing !=null || infoRing !='') {
        let currentCurrency = Shopify.currency.active;
        let currentCurrencySymbol = $('body').attr('data-currency');
        let currentRate = window.Shopify.currency.rate;
        let productId = infoRing.setting_product_id?infoRing.setting_product_id:'0';
        let variantSku = infoRing.setting_variant_sku?infoRing.setting_variant_sku:'SET1_14K_GOLD_ABC_3MM';
        loaddata(productId,variantSku,infoRing.stone_shape,infoRing.setting_selected_metal,infoRing.setting_selected_carat_size);

        let caratDiamond = toNumberFormat(infoRing.stone_carat);
        let caratDiamond1 = toNumberFormat(infoRing.stone_carat1);
        let diamondPrice = toNumberFormat(infoRing.stone_price * currentRate);
        let diamondPrice1 = toNumberFormat(infoRing.stone_price1 * currentRate);
        let caratSetting= toNumberFormat(infoRing.setting_selected_side_carat_weight);
        let settingPrice= toNumberFormat((infoRing.setting_variant_price/100));

        let totalPrice =  parseFloat(infoRing.stone_price1  * currentRate) + parseFloat(infoRing.stone_price  * currentRate) + parseFloat(infoRing.setting_variant_price)/100; 
        totalPrice= toNumberFormat(totalPrice);   

        let totalCarat = parseFloat(infoRing.stone_carat1) + parseFloat(infoRing.stone_carat) + infoRing.setting_selected_side_carat_weight;
        totalCarat=toNumberFormat(totalCarat);  
      
        let cutString = '';
        if(infoRing.stone_shape == 'Round'){
            cutString = `${infoRing.stone_cut} cut `;
        }
       document.getElementById('diamond-short-detail').innerHTML = `${caratDiamond} Carat  ${infoRing.stone_shape} Diamond `;
        document.getElementById('diamond_description').innerHTML = `${cutString} <span class="dot">•</span> ${infoRing.stone_color} Color <span class="dot">•</span> ${infoRing.stone_clarity} Clarity`;
        document.getElementById('diamond-price').innerHTML = currentCurrencySymbol+''+diamondPrice; 



       let cutString1 = '';
        if(infoRing.stone_shape1 == 'Round'){
            cutString1 = `${infoRing.stone_cut1} cut `;
        }
       document.getElementById('diamond-short-detail1').innerHTML = `${caratDiamond1} Carat  ${infoRing.stone_shape1} Diamond `;
        document.getElementById('diamond_description1').innerHTML = `${cutString1} <span class="dot">•</span> ${infoRing.stone_color1} Color <span class="dot">•</span> ${infoRing.stone_clarity1} Clarity`;
        document.getElementById('diamond-price1').innerHTML = currentCurrencySymbol+''+diamondPrice1; 


      
        let caratString = caratSetting>0?` with ${caratSetting} carats of diamonds.`:'';

        document.getElementById('setting-short-detail').innerHTML = `${infoRing.setting_selected_metal} ${infoRing.setting_product_name} earrings ${caratString}`;
        document.getElementById('setting-price').innerHTML = currentCurrencySymbol+''+settingPrice;

        let extraTotalWeightString = caratSetting>0?' (includes center stone).':'.';
        document.getElementById('ring-short-detail').innerHTML = `Your total diamond weight is ${totalCarat} carats of diamonds${extraTotalWeightString}`;
        document.getElementById('total-price').innerHTML = currentCurrencySymbol+''+totalPrice;

             
               // Let's validate if there's a diamond selected to be in stock and the diamond carat fits the setting carat
        if(infoRing.stone_carat && infoRing.setting_variant_id){
                    document.getElementById('diamond-with-setting').disabled = false;
                    document.getElementById('diamond-with-setting').innerHTML = 'ADD TO CART |' +currentCurrencySymbol+''+totalPrice;
                
            }
            else {
                if(infoRing.stone_carat && infoRing.stone_carat > 0){
                    if(!infoRing.setting_variant_id){
                        //There's no setting selected we need to direct the customer to the settings page
                        let caractDictValue = getCaratDictionaryValueForWizard(infoRing.stone_carat);
                        if(wizardInfo.stone_shape.toLowerCase().includes('cushion')){
                            wizardInfo.stone_shape = 'Cushion';
                        }
                        let shapeDictValue = 'dyo_shape_'+infoRing.stone_shape.toLowerCase();
                        window.location.href = '/collections/design-your-own-earrings/'+caractDictValue+'+'+shapeDictValue;
                    }
                }
                else {
                    if(infoRing.setting_variant_id){
                        //There's no diamond selected we need to direct the customer to the diamonds page
                        window.location.href = '/pages/dyoe-diamonds';
                    }
                    else {
                        //There's no diamond nor setting selected we need to direct the customer to the diamonds page
                        window.location.href = '/pages/dyoe-diamonds?sw=d';
                    }
                }
            }
       

    }
}
function calcDeliveryDate(delivery_Date,qntymore,qntyless,price){ 


              var wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_dyoe'));
              var stone_deliver = 0;
                if(wizardInfo != undefined && wizardInfo != null){
                if(wizardInfo.stone_delivery != undefined && wizardInfo.stone_delivery != null){
                stone_deliver = parseInt(wizardInfo.stone_delivery)
                }
                }
              var skipDates = $('.nacklace_container').attr('data-exclued-date');
              var qnty_more_data = parseInt($('.nacklace_container').attr('data-qty-more'));
              var qnty_less_data =  parseInt($('.nacklace_container').attr('data-qty-less'));
              if(qntymore == undefined || qntymore == 0){
              var qnty_more_data = qnty_more_data;
              } else{
              var qnty_more_data = qntymore;  
              }  
              if(qntyless == undefined || qntyless == 0){
              var qnty_less_data = qnty_less_data;
              } else{
              var qnty_less_data = qntyless;  
              } 
              if(delivery_Date >= 1){
                
              if(qnty_more_data == 0){
              qnty_more_data_updated = qnty_more_data + 1;
              } else{
              qnty_more_data_updated = qnty_more_data;
              }          
              const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
              "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
              ];
              let today = new Date();
              const pstDate = today.toLocaleString("en-US", { timeZone: "America/New_York" });
              let hh = new Date(pstDate).getHours();
              if(hh > 15){
              var dd = today.getDate() + 1 ; 
              }  else{
              var dd = today.getDate();
              }
          // if(stone_deliver > 0){
              //   dd = dd + stone_deliver
              // }
              let mm = today.getMonth() + 1;
              let yyyy = today.getFullYear();
              var startDate = yyyy + '/' + mm + '/' + dd;
              startDate = new Date(startDate);
              var endDate = "";
              var noOfDaysToAdd = qnty_more_data_updated;
              var count = 0;
              while(count < noOfDaysToAdd){
              endDate = new Date(startDate.setDate(startDate.getDate() + 1)); 
              if (skipDates.includes(endDate.toISOString().substring(0, 10))) {
              continue;
              }
              if (endDate.getDay() != 0 && endDate.getDay() != 6 &&  !skipDates.includes(startDate.toISOString().substring(0, 10))) {
              count++;
              }
              }
              const weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];   
              var country_loc = localStorage.getItem("countryus");
              
              if(country_loc == "yes") {
              if(price < 250 ){  
              var newDate =  new Date(endDate.getTime() + (3 * 86400000));
              var newDate2 = new Date(endDate.getTime() + (6 * 86400000));
              if(qnty_less_data == 0){
              var newdd = newDate.getDate()- 1;
              var newddrange = newDate2.getDate();
              } else{
              var newdd = newDate.getDate();
              var newddrange = newDate2.getDate();
              }
              var newmm = newDate.getMonth() + 1;
              
              if(qnty_less_data == 0){
              var dayrange = weekday[newDate2.getDay()];
              var day = weekday[newDate.getDay() -1];
              } else{
              var dayrange = weekday[newDate2.getDay()];
              var day = weekday[newDate.getDay()];
              }
              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd +' - '+dayrange+', '+monthNames[newDate2.getMonth()] + ' ' +newddrange;
              } else{
              var newDate =  new Date(endDate.getTime() + (2 * 86400000));
              if(qnty_less_data == 0){
              var newdd = newDate.getDate()- 1;
              
              } else{
              var newdd = newDate.getDate();
              }
              var newmm = newDate.getMonth() + 1;
              if(qnty_less_data == 0){
              var day = weekday[newDate.getDay() -1];
              } else{
              var day = weekday[newDate.getDay()];
              }
              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd;
              }
              } else{                   var newDate =  new Date(endDate.getTime());
              if(qnty_less_data == 0){
              var newdd = newDate.getDate()- 1; 
              } else{
              var newdd = newDate.getDate();  
              }
              if(qnty_less_data == 0){
              var day = weekday[newDate.getDay() -1];
              } else{
              var day = weekday[newDate.getDay()];
              } 
              var newmm = newDate.getMonth() + 1;
              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd;
              }
              var text = document.createTextNode(finalDate).textContent;
              document.getElementById('est_delivery_date').innerHTML = text;    
              document.getElementById('delivery_date').value = text; 
              } else if(delivery_Date < 1){
            
              if(qnty_less_data == 0){
              qnty_less_data_updated = parseInt(qnty_less_data) + 1;
              } else{
              qnty_less_data_updated = qnty_less_data;
              }

              const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
              "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
              ];
              let today = new Date();
              const pstDate = today.toLocaleString("en-US", { timeZone: "America/New_York" });
              let hh = new Date(pstDate).getHours();
              if(hh > 15){
              if(qnty_less_data == 0){
              var dd = today.getDate() + 1 ; 
              } else{
              var dd = today.getDate() + 2 ;  
              }
              }  else{
              if(qnty_less_data == 0){
              var dd = today.getDate(); 
              } else{
              var dd = today.getDate() + 1 ;  
              }
              }
               if(dd > 30){
                var dd = dd -3; 
               }
              //   if(stone_deliver > 0){
              //   dd = dd + stone_deliver
              // }
       
              let mm = today.getMonth() + 1;
              let yyyy = today.getFullYear();
              var startDate = yyyy + '/' + mm + '/' + dd;
              startDate = new Date(startDate);
              var startDateRange = yyyy + '/' + mm + '/' + dd;
              startDateRange = new Date(startDateRange);
              var startDateOUtUs = yyyy + '/' + mm + '/' + dd;
              startDateOUtUs = new Date(startDateOUtUs); 
              var endDate = "";
              var endDateoutus = "";
              var endDateRange = "";




              var country_loc = localStorage.getItem("countryus");
              if(country_loc == 'yes'){
              if(price < 251 ){
              if(qnty_less_data == 0){
              var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 2 ; 
              var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 5 ; 
              } else{
              var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 3 ; 
              var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 6 ; 
              }  
              } else{
              if(qnty_less_data == 0){
              var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 1 ;
              var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 4 ; 
              } else{
              var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 2 ;
              var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 5 ; 
              }   
              }  
              } else{
              if(qnty_less_data == 0){
              var noOfDaysToAddoutusa = parseInt(qnty_less_data_updated) + 1;  
              } else{
              var noOfDaysToAddoutusa = qnty_less_data_updated; 
              }   
              }
              var countoutus = 0;
              while(countoutus < noOfDaysToAddoutusa ){
              endDateoutus = new Date(startDateOUtUs.setDate(startDateOUtUs.getDate() + 1)); 

              if (endDateoutus.getDay() != 0 && endDateoutus.getDay() != 6) {
              countoutus++;
              }
              }
              var count = 0;
              while(count < noOfDaysToAdd ){
              endDate = new Date(startDate.setDate(startDate.getDate() + 1)); 
              
              if (endDate.getDay() != 0 && endDate.getDay() != 6 ) {
              count++;
              }
              }
              
              
              var count1 = 0;
              while(count1 < noOfDaysToAddrange ){
              endDateRange = new Date(startDateRange.setDate(startDateRange.getDate() + 1)); 
             
              if (endDateRange.getDay() != 0 && endDateRange.getDay() != 6 ) {
              count1++;
              }
              }
             
              const weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]; 
              var country_loc = localStorage.getItem("countryus");
              if(country_loc == "yes") {
              var newDateRange =  new Date(endDateRange.getTime());
              var newDaten =  new Date(endDateRange.getTime() + (1 * 86400000));
              var skipDates = $('.nacklace_container').attr('data-exclued-date');
              var dateString = newDaten.toISOString().slice(0, 10);
              if (skipDates.includes(dateString)) {
              var newDateRange =  new Date(endDateRange.getTime() + (1 * 86400000));
              var newDatett =  new Date(endDateRange.getTime() + (2 * 86400000));   
              var dateString2 = newDatett.toISOString().slice(0, 10);
              if (skipDates.includes(dateString2)) {
              var newDateRange =  new Date(endDateRange.getTime() + (2 * 86400000));
              var newDatettt =  new Date(endDateRange.getTime() + (3 * 86400000));
              var dateString3 = newDatettt.toISOString().slice(0, 10);
              if (skipDates.includes(dateString3)) {
              var newDateRange =  new Date(endDateRange.getTime() + (3 * 86400000));
              var newDatettttt =  new Date(endDateRange.getTime() + (4 * 86400000));
               var dateString4 = newDatettttt.toISOString().slice(0, 10);
              if (skipDates.includes(dateString4)) {
              var newDateRange =  new Date(endDateRange.getTime() + (4 * 86400000));
              }  
              }
              }
              }
              
              var newDate =  new Date(endDate.getTime());
              var newDaten =  new Date(endDate.getTime() + (1 * 86400000));
              var skipDates = $('.nacklace_container').attr('data-exclued-date');
              var dateString = newDaten.toISOString().slice(0, 10);
              if (skipDates.includes(dateString)) {
              var newDate =  new Date(endDate.getTime() + (1 * 86400000));
              var newDatett =  new Date(endDate.getTime() + (2 * 86400000));   
              var dateString2 = newDatett.toISOString().slice(0, 10);
              if (skipDates.includes(dateString2)) {
              var newDate =  new Date(endDate.getTime() + (2 * 86400000));
              var newDatettt =  new Date(endDate.getTime() + (3 * 86400000));
              var dateString3 = newDatettt.toISOString().slice(0, 10);
              if (skipDates.includes(dateString3)) {
              var newDate =  new Date(endDate.getTime() + (3 * 86400000));
              var newDatettttt =  new Date(endDate.getTime() + (4 * 86400000));
               var dateString4 = newDatettttt.toISOString().slice(0, 10);
              if (skipDates.includes(dateString4)) {
              var newDate =  new Date(endDate.getTime() + (4 * 86400000));
              }  
              }
              }
              }
              var newddRange = newDateRange.getDate();
              var newmmRange = newDateRange.getMonth() + 1;
              let dayRange = weekday[newDateRange.getDay()];
              var newdd = newDate.getDate();
              var newmm = newDate.getMonth() + 1;
              let day = weekday[newDate.getDay()];
              if(newdd == "1" || newdd == "21" || newdd == "31"){
              var dayt = newdd+'st';
              } else if(newdd == "2" || newdd == "22"){
               var dayt = newdd+'nd';
              } else if(newdd == "3" || newdd == "33"){
              var dayt = newdd+'rd';
              } else{
              var dayt = newdd+'th';
              }
              if(newddRange == "1" || newddRange == "21" || newddRange == "31"){
              var daytrange = newddRange+'st';
              } else if(newddRange == "2" || newddRange == "22"){
               var daytrange = newddRange+'nd';
              } else if(newddRange == "3" || newddRange == "33"){
              var daytrange = newddRange+'rd';
              } else{
              var daytrange = newddRange+'th';
              }
              if(price < 251 ){
              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd +' - '+dayRange+', '+monthNames[newDateRange.getMonth()] + ' ' +daytrange;
              } else{
              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +dayt ;
              }  
              var text = document.createTextNode(finalDate);
              var text = document.createTextNode(finalDate).textContent;
                console.log(text)
              document.querySelector('#deliverydate').innerHTML = text;
              } else{
            
              var newDate =  new Date(endDateoutus.getTime());
              var newDaten =  new Date(endDateoutus.getTime() + (1 * 86400000));
            
              var skipDates = $('.nacklace_container').attr('data-exclued-date');
              var dateString = newDaten.toISOString().slice(0, 10);
              if (skipDates.includes(dateString)) {
              var newDate =  new Date(endDateoutus.getTime() + (1 * 86400000));
              var newDatett =  new Date(endDateoutus.getTime() + (2 * 86400000));   
              var dateString2 = newDatett.toISOString().slice(0, 10);
              if (skipDates.includes(dateString2)) {
              var newDate =  new Date(endDateoutus.getTime() + (2 * 86400000));
              var newDatettt =  new Date(endDateoutus.getTime() + (3 * 86400000));
              var dateString3 = newDatettt.toISOString().slice(0, 10);
              if (skipDates.includes(dateString3)) {
              var newDate =  new Date(endDateoutus.getTime() + (3 * 86400000));
              var newDatettttt =  new Date(endDateoutus.getTime() + (4 * 86400000));
               var dateString4 = newDatettttt.toISOString().slice(0, 10);
              if (skipDates.includes(dateString4)) {
              var newDate =  new Date(endDateoutus.getTime() + (4 * 86400000));
              }  
              }
              }
              }
              var newdd = newDate.getDate();
              var newmm = newDate.getMonth() + 1;
              let day = weekday[newDate.getDay()];
              if(newdd == "1" || newdd == "21" || newdd == "31"){
              var dayt = newdd+'st';
              } else if(newdd == "2" || newdd == "22"){
               var dayt = newdd+'nd';
              } else if(newdd == "3" || newdd == "33"){
              var dayt = newdd+'rd';
              } else{
              var dayt = newdd+'th';
              }
              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd ;
              }
              var endDateSpecial = $('.end_date_sp').text();
              var startDateSpecial = $('.start_date_sp').text();
              const date2 = new Date(endDateSpecial);
              const date1 = new Date(startDateSpecial);
              const date3 = new Date(newDate);
              const date4 = new Date(newDateRange);
              if(country_loc == "yes") {  
              if(price < 251 ){
              if (date4 > date1 && date4 <= date2) {
              if(document.getElementById('special_ocassion') != null){
              document.getElementById('special_ocassion').style.display = 'flex';
              document.getElementById('special_ocassion_id').value = '1';
              }
              } else{
              if(document.getElementById('special_ocassion') != null){
              document.getElementById('special_ocassion').style.display = 'none';
              document.getElementById('special_ocassion_id').value = '0'; 
              }
              }
              } else{
              if (date3 > date1 && date3 <= date2) {
              if(document.getElementById('special_ocassion') != null){
              document.getElementById('special_ocassion').style.display = 'flex';
              document.getElementById('special_ocassion_id').value = '1';
              }
              } else{
              if(document.getElementById('special_ocassion') != null){
              document.getElementById('special_ocassion').style.display = 'none';
              document.getElementById('special_ocassion_id').value = '0'; 
              }
              }
              }  
              }              
              var text = document.createTextNode(finalDate).textContent;
                console.log(text);
               document.querySelector('#deliverydate').innerHTML = text;
               } 
              }
loadInfoRing();
bindEvents();
function getdiamond_img(diamond_id){  
url = window.API_URL +`diamonds/new/dyor/settings/${diamond_id}`;
     fetch(url, {
        method: 'GET',        
        headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
    }).then(res => res.json()).then(async diamond => {
        if(diamond.Column812.indexOf('d=') > -1 && diamond.Column812.indexOf('surl=') > -1){
                   var Videourl=diamond.Column812;
                
                  $(`#grid-img-diamond #diamond-img2,div#carouselExampleIndicators .carousel-inner .diamond-img2`).html(`<div class="main_container_first"><iframe data-scaling="true"  seamless="seamless" src="${Videourl}" scrolling="no" width=420 height=580></iframe></div>`);
                  if(diamond.img_status2 == 1){
                   $(`#grid-img-diamond #diamond-img3,div#carouselExampleIndicators .carousel-inner .diamond-img3`).html(`<img src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID2}.jpeg">`);
                 }  
                }
                else if(diamond.Column812.indexOf('.mp4') > -1){
                var video_mp4 = true
                var Videourl=diamond.Column812;
                $(`#grid-img-diamond #diamond-img2,div#carouselExampleIndicators .carousel-inner .diamond-img2`).html(`<video preload=metadata width="420" playsinline=""  height="420" autoplay  loop muted><source src="${Videourl}" type="video/mp4"> </video>`);  
                 if(diamond.img_status2 == 1){
                   $(`#grid-img-diamond #diamond-img3,div#carouselExampleIndicators .carousel-inner .diamond-img3`).html(`<img src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID2}.jpg">`);
                 }  
                }else if(diamond.Column812 !=''){
                    $(`#grid-img-diamond #diamond-img2,div#carouselExampleIndicators .carousel-inner .diamond-img2`).html(`<div class="main_container_first"><iframe src="${diamond.Column812}"  scrolling="no" width=420 height=580></iframe></div>`); 
                 if(diamond.img_status2 == 1){
                   $(`#grid-img-diamond #diamond-img3,div#carouselExampleIndicators .carousel-inner .diamond-img3`).html(`<img src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID2}.jpeg">`);
                 }  
                }else{
                  if(isV360(diamond.Image_URL)){
                    $(`#grid-img-diamond #diamond-img2,div#carouselExampleIndicators .carousel-inner .diamond-img2`).html(`<div class="main_container_first"><iframe src="${diamond.Image_URL2}" scrolling="no" width=420 height=580></iframe></div>`);
                   if(diamond.img_status2 == 1){
                   $(`#grid-img-diamond #diamond-img3,div#carouselExampleIndicators .carousel-inner .diamond-img3`).html(`<img src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID2}.jpeg">`);
                 }  
                  }
                }

        if(diamond.Column811.indexOf('d=') > -1 && diamond.Column811.indexOf('surl=') > -1){
                   var Videourl1=diamond.Column811;
                
                  $(`#grid-img-diamond #diamond-img3,div#carouselExampleIndicators .carousel-inner .diamond-img3`).html(`<div class="main_container_first"><iframe data-scaling="true"  seamless="seamless" src="${Videourl1}" scrolling="no" width=420 height=580></iframe></div>`);
                  if(diamond.img_status1 == 1){
                   $(`#grid-img-diamond #diamond-img4,div#carouselExampleIndicators .carousel-inner .diamond-img4`).html(`<img src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID1}.jpeg">`);
                 }  
                }
                else if(diamond.Column811.indexOf('.mp4') > -1){
                var video_mp4 = true
                var Videourl1=diamond.Column811;
                $(`#grid-img-diamond #diamond-img3,div#carouselExampleIndicators .carousel-inner .diamond-img3`).html(`<video preload=metadata width="420" playsinline=""  height="420" autoplay  loop muted><source src="${Videourl1}" type="video/mp4"> </video>`);  
                 if(diamond.img_status1 == 1){
                   $(`#grid-img-diamond #diamond-img4,div#carouselExampleIndicators .carousel-inner .diamond-img4`).html(`<img src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID1}.jpg">`);
                 }  
                }else if(diamond.Column811 !=''){
                    $(`#grid-img-diamond #diamond-img3,div#carouselExampleIndicators .carousel-inner .diamond-img3`).html(`<div class="main_container_first"><iframe src="${diamond.Column811}"  scrolling="no" width=420 height=580></iframe></div>`); 
                 if(diamond.img_status1 == 1){
                   $(`#grid-img-diamond #diamond-img4,div#carouselExampleIndicators .carousel-inner .diamond-img4`).html(`<img src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID1}.jpeg">`);
                 }  
                }else{
                  if(isV360(diamond.Image_URL1)){
                    $(`#grid-img-diamond #diamond-img2,div#carouselExampleIndicators .carousel-inner .diamond-img2`).html(`<div class="main_container_first"><iframe src="${diamond.Image_URL1}" scrolling="no" width=420 height=580></iframe></div>`);
                   if(diamond.img_status1 == 1){
                   $(`#grid-img-diamond #diamond-img3,div#carouselExampleIndicators .carousel-inner .diamond-img3`).html(`<img src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID1}.jpeg">`);
                 }  
                  }
                }
        
    })
}
function checkImageExists(imageUrl, callback) {
    var img = new Image();
    img.onload = function() {
        // The image loaded successfully
        callback(true);
    };
    img.onerror = function() {
        // The image could not be loaded
        callback(false);
    };
    img.src = imageUrl;
}